import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../api";
import RailGroup from "./RailGroup";
import { callFacts, dayLabel } from "../calls/callsModel.mjs";

/*
 * CALLS ON THE LEAD RECORD: his calls with this company, from the call log
 * (Meetings ▸ Calls, src/calls). Each one opens the call there, with its notes
 * and transcript; "All N calls" opens the log on this company.
 *
 * The company's, not the situation's, so it sits outside the matrix like Lists
 * and the Prospect Room. The log's scope holds here too: the calls he was on,
 * and for a client only those from before the win (their catch-ups live in the
 * auditor). Its own fetch (GET /companies/:id/calls); nothing is drawn while a
 * company has none.
 */
const SHOWN = 6;

export default function CallsGroup({ record, sheet }) {
  const companyId = record.company && record.company.id;
  const [calls, setCalls] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!companyId) return undefined;
    let alive = true;
    api(`/companies/${companyId}/calls`)
      .then((d) => alive && setCalls(d.calls || []))
      .catch(() => alive && setCalls([]));
    return () => {
      alive = false;
    };
  }, [companyId]);

  if (!calls || !calls.length) return null;
  const last = calls[0];
  const summary = `Last ${dayLabel(last.started_at)} · ${last.title}`;
  return (
    <RailGroup id="calls" title="Calls" count={calls.length} summary={summary} open={open} onToggle={setOpen} sheet={sheet}>
      <ul className="rec-calls">
        {calls.slice(0, SHOWN).map((c) => (
          <li key={c.id}>
            <Link to={`/meetings/calls/${encodeURIComponent(c.id)}`} className="rec-calls__item">
              <span className="rec-strong">{c.title}</span>
              <span className="rec-sub">{callFacts(c)}</span>
            </Link>
          </li>
        ))}
      </ul>
      <Link to={`/meetings/calls?company=${companyId}`} className="rec-link rec-calls__all">
        {calls.length > SHOWN ? `All ${calls.length} calls →` : "Open in Calls →"}
      </Link>
    </RailGroup>
  );
}
